module.exports = __webpack_public_path__ + "static/media/PlutoBold.eacab73a.otf";